import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgxFileDropModule } from 'ngx-file-drop';
import { ToastrModule } from 'ngx-toastr';

// Material
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatBadgeModule } from '@angular/material/badge'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatChipsModule } from '@angular/material/chips'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatOptionModule } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper'
import { MatMenuModule } from '@angular/material/menu'
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { GrantsDirective } from '../core/directives/grants.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { HeaderComponent } from './themes/header/header.component';
import { LayoutComponent } from './themes/layout/layout.component';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './themes/footer/footer.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { LeftBarComponent } from './themes/left-bar/left-bar.component';
import { MatTreeModule } from '@angular/material/tree';
import { LayoutAuthComponent } from './themes/layout-auth/layout-auth.component';
import { MessageDialogComponent } from './partials/message-dialog/message-dialog.component';
import { FormControlComponent } from './partials/form-control/form-control.component';
import { FileUploadComponent } from './partials/file-upload/file-upload.component';
import { BtnActionComponent } from './partials/btn-action/btn-action.component';
import { PowerBiComponent } from '../power-bi/power-bi.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { BreadcrumbComponent } from './themes/breadcrumb/breadcrumb.component';
import { TableComponent } from './partials/table/table.component';
import { TemplateComponent } from './dialogs/template/template.component';
import { PdfUserGuideUploadComponent } from './dialogs/pdf-user-guide-upload/pdf-user-guide-upload.component';
import { FormBuilderComponent } from './partials/form-builder/form-builder.component';
import { NgChartsModule } from 'ng2-charts';
import { ApproachProfileComponent } from './dialogs/approach-profile/approach-profile.component';
import { CopyApproachProfilesComponent } from './dialogs/copy-approach-profiles/copy-approach-profiles.component';
import { UserGuideViewComponent } from './dialogs/user-guide-view/user-guide-view.component';
import { UserGuideEditorComponent } from './dialogs/user-guide-editor/user-guide-editor.component';
import { HelpButtonComponent } from './partials/help-button/help-button.component';
import { StringListEditorComponent } from './partials/string-list-editor/string-list-editor.component';
import { CopyStipendConfigComponent } from './dialogs/copy-stipend-config/copy-stipend-config.component';
import { MarkdownModule } from 'ngx-markdown';
import { QuillModule } from 'ngx-quill';
import { AttestationComponent } from './dialogs/attestation/attestation.component';
import { TeachingFieldComponent } from './dialogs/teaching-field/teaching-field.component';
import { TeachingFieldAssignmentComponent } from './dialogs/teaching-field-assignment/teaching-field-assignment.component';
import { NotificationTemplateDialogComponent } from './dialogs/notification-template/notification-template.component';

const matImports = [
  MatTreeModule,
  MatIconModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatCheckboxModule,
  MatButtonToggleModule,
  MatBadgeModule,
  MatToolbarModule,
  MatChipsModule,
  MatExpansionModule,
  MatSnackBarModule,
  MatOptionModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatDialogModule,
  MatStepperModule,
  MatMenuModule,
  MatTabsModule,
  MatCardModule,
  MatSidenavModule,
  MatDividerModule,
  MatListModule,
  MatSlideToggleModule,
  MatTooltipModule
];

const coreImports = [
  FormsModule,
  ReactiveFormsModule,
  NgxFileDropModule,
  PowerBIEmbedModule,
  NgChartsModule
]

const components = [
  LayoutComponent,
  LayoutAuthComponent,
  HeaderComponent,
  LeftBarComponent,
  FooterComponent,
  BreadcrumbComponent,

  MessageDialogComponent,
  FormControlComponent,
  FileUploadComponent,
  BtnActionComponent,
  PowerBiComponent,
  TableComponent,
  TemplateComponent,
  PdfUserGuideUploadComponent,
  ApproachProfileComponent,
  FormBuilderComponent,
  CopyApproachProfilesComponent,
  UserGuideViewComponent,
  UserGuideEditorComponent,
  HelpButtonComponent,
  AttestationComponent,
  TeachingFieldComponent,
  TeachingFieldAssignmentComponent,
  NotificationTemplateDialogComponent,
  StringListEditorComponent,
  CopyStipendConfigComponent
]

@NgModule({
  declarations: [
    GrantsDirective,
    ...components
  ],
  imports: [
    CommonModule,
    RouterModule,
    ...matImports,
    ...coreImports,
    ToastrModule.forRoot(),
    MarkdownModule.forRoot(),
    QuillModule.forRoot(),
  ],
  exports: [
    GrantsDirective,
    ...components,
    ...matImports,
    ...coreImports,
    MarkdownModule,
    QuillModule,
  ]
})
export class SharedModule { }
